function isNonNullable(value) {
  return value != null;
}
export {
  isNonNullable
};
//# sourceMappingURL=isNonNullable.js.map